import http, { endpoints } from '../http'
import { PaginatedListResponseType } from '../types'
import { IBranch } from '../users/models'
import { IBranchDto, IWhitelabelDto } from './dtos'
import { mapBranchFromDto, mapWhitelabelSettingsFromDto } from './helpers'
import { IBrachSearchParams } from './models'

const datahubClient = http.createClient(`${endpoints.datahub}`)

export default class DepartmentApi {
	static async searchBranchByKey(params: IBrachSearchParams): Promise<PaginatedListResponseType<IBranch>> {
		const response = await datahubClient.post<PaginatedListResponseType<IBranchDto>>('/Branch/search', params)
		return {
			total: response?.data?.total || 0,
			results: response?.data?.results.map(mapBranchFromDto) || [],
		}
	}

	static async getBranchById(branchId: IBranch['id']) {
		const response = await datahubClient.get<IBranchDto>(`/Branch/id/${branchId}`)
		return response.data
	}

	static async getWhitelabelSettings() {
		const response = await datahubClient.get<IWhitelabelDto>('/webshop/whitelabel')
		return response?.data ? mapWhitelabelSettingsFromDto(response.data) : undefined
	}

	static async getUserBranches() {
		const response = await datahubClient.get<IBranchDto[]>('/Authentication/user/branches')
		return response.data?.map(mapBranchFromDto)
	}

	static async getCanBranchCreateOrder(branchId: IBranch['id']) {
		try {
			const response = await datahubClient.post('/branch/ordercreationblacklistings', [branchId])
			return (
				response == null ||
				response == undefined ||
				response.data == null ||
				response.data == undefined ||
				(Object.keys(response.data).length === 0 && response.data.constructor === Object) ||
				!response.data[branchId]
			)
		} catch (error) {
			console.log('Error occurred when calling getCanBranchCreateOrder, for branchId: ' + branchId)
			console.error(error)
		}

		return true
	}
}
